import React, { useState } from 'react';
import { translate } from '../Services/translation';
import { receive, loadError } from '../Actions/Cart.action';
import { useDispatch } from 'react-redux';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService } from '../Services/Cart.service';
import constants from "../constants";

const handleAddToCart = async (articleNumber, quantity, dispatch) => {
    try {
        const cart = await addToCartService({ articleNumber, quantity });
        dispatch(receive(cart));
        return true;
    } catch (ex) {
        dispatch(catchError(ex, (error) => loadError(error)));
        return false;
    }
};

const groupResult = (result) => {
    const groups = {};

    result.forEach((item) => {
        if (groups[item.category]) {
            groups[item.category].items.push(item);
        } else {
            groups[item.category] = { name: item.category, items: [item] };
        }
    });
    return groups;
};

const ResultGroupItem = ({ group, searchUrl }) => {
    const [quantity, setQuantity] = useState(1);
    const [addedToCart, setAddedToCart] = useState(false);
    const dispatch = useDispatch();
    const isViewOnlyGroup = constants.isViewOnlyGroup;

    if (!group) return null;

    const renderGroupHeader = () => {
        const firstItem = group.items[0];
        if (firstItem?.showAll === false && firstItem?.category !== 'NoHit') {
            return (
                <p className="quick-search-result__group-header">
                    {translate(`quicksearchheader.${group.name.toLowerCase()}`)}
                </p>
            );
        }
    };

    const renderItem = (item, index) => {
        const linkClass = item.showAll
            ? 'quick-search-result__show-all'
            : `quick-search-result__link ${
                  item.url ? '' : 'quick-search-result__link--disabled'
              }`;
        const linkHref = item.showAll ? searchUrl : item.url;

        return (
            <li
                key={`${item.name}-${index}`}
                className="quick-search-result__item"
            >
                <a className={linkClass} href={linkHref}>
                    {item.hasImage && item.imageSource && (
                        <img
                            className="quick-search-result__image"
                            src={item.imageSource}
                        />
                    )}
                    <div>
                        <p>{item.name}</p>
                        {item.showAll === false && (
                            <p className="quick-search-result__article-number">
                                {item.articleNumber}
                            </p>
                        )}
                    </div>
                </a>
                {(group.name == 'ArticleNumberMatch' && !isViewOnlyGroup) && (
                    <div className="quick-search-result__actions">
                        <div className="quick-search-result__actions__counter">
                            <button
                                id="itemcounter-remove"
                                onClick={() => setQuantity(quantity - 1)}
                            >
                                -
                            </button>
                            <span id="itemcounter-current">{quantity}</span>
                            <button
                                id="itemcounter-add"
                                onClick={() => setQuantity(quantity + 1)}
                            >
                                +
                            </button>
                        </div>

                        <button
                            className="quick-search-result__actions__button"
                            onClick={() => {
                                setAddedToCart(true),
                                    handleAddToCart(
                                        item.articleNumber,
                                        quantity,
                                        dispatch
                                    ).then(() => {
                                        setTimeout(() => {
                                            setAddedToCart(false);
                                        }, '1500');
                                    });
                            }}
                        >
                            {addedToCart ? (
                                <span className="quick-search-result__actions__button__icon--check"></span>
                            ) : (
                                <span className="quick-search-result__actions__button__icon--cart"></span>
                            )}
                        </button>
                    </div>
                )}
            </li>
        );
    };

    return (
        <div className="quick-search-result__group">
            {renderGroupHeader()}
            <ul>{group.items.map(renderItem)}</ul>
        </div>
    );
};

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
    const resultGroups = groupResult(result);

    const hasItemsInSecondColumn = ['Category', 'Brands', 'Pages'].some(
        (group) => resultGroups[group]?.items.length > 0
    );

    return (
        <div className="quick-search-result">
            {resultGroups['NoHit'] ? (
                <div className="quick-search-result__column">
                    <ResultGroupItem
                        group={resultGroups['NoHit']}
                        selectedItem={selectedItem}
                        searchUrl={searchUrl}
                    />
                </div>
            ) : (
                <>
                    <div className="quick-search-result__exact-match">
                        <ResultGroupItem
                            group={resultGroups['ArticleNumberMatch']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                        />
                    </div>
                    <div className="quick-search-result__grid">
                        <div className="quick-search-result__column">
                            <ResultGroupItem
                                group={resultGroups['Products']}
                                selectedItem={selectedItem}
                                searchUrl={searchUrl}
                            />
                        </div>
                        {hasItemsInSecondColumn && (
                            <div className="quick-search-result__column">
                                <ResultGroupItem
                                    group={resultGroups['Categories']}
                                    selectedItem={selectedItem}
                                    searchUrl={searchUrl}
                                />
                                <ResultGroupItem
                                    group={resultGroups['Brands']}
                                    selectedItem={selectedItem}
                                    searchUrl={searchUrl}
                                />
                                <ResultGroupItem
                                    group={resultGroups['Pages']}
                                    selectedItem={selectedItem}
                                    searchUrl={searchUrl}
                                />
                            </div>
                        )}
                    </div>
                </>
            )}
            {resultGroups['ShowAll'] && (
                <div className="quick-search-result__show-all">
                    <ResultGroupItem
                        group={resultGroups['ShowAll']}
                        selectedItem={selectedItem}
                        searchUrl={searchUrl}
                    />
                </div>
            )}
        </div>
    );
};

export default QuickSearchResult;
